export default "__VITE_ASSET__748$9ybX__"